import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP } from "../apiRoutes";

const mutateAddInventory = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(INVENTORY_SETUP, data);
};

const useAddInventorySetupMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddInventory,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch inventory setup queries
      queryClient.invalidateQueries({
        queryKey: ["inventorySetup"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddInventorySetupMutation;
